<template>
  <div class="post-page">

    <!-- 顶部工具栏 -->
    <div class="toolbar">
      <el-input
          v-model="searchKeyword"
          placeholder="搜索文章标题"
          clearable
          class="search-input"
          @clear="fetchList"
          @keyup.enter.native="fetchList"
      >
        <template #append>
          <el-button @click="fetchList">搜索</el-button>
        </template>
      </el-input>

      <el-button type="primary" @click="goCreate">
        新增文章
      </el-button>
    </div>

    <!-- 文章卡片区域 -->
    <el-row :gutter="20">
      <el-col
          :span="6"
          v-for="item in filteredPosts"
          :key="item.id"
      >
        <el-card class="post-card" shadow="hover">

          <!-- 封面区域 -->
          <div class="cover-wrapper">
            <img class="cover" :src="item.cover" alt="cover" />
          </div>

          <!-- 内容 -->
          <div class="info">
            <h3 class="title">{{ item.title }}</h3>
            <p class="desc">{{ item.summary }}</p>

            <el-tag
                size="small"
                :type="item.status === 'published' ? 'success' : 'info'"
            >
              {{ item.status === 'published' ? "已发布" : "草稿" }}
            </el-tag>
          </div>

          <!-- 操作按钮 -->
          <div class="actions">
            <el-button size="small" @click="goEdit(item.id)">编辑</el-button>
            <el-button size="small" type="danger" @click="handleDelete(item.id)">
              删除
            </el-button>
          </div>

        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { useRouter } from "vue-router";

const router = useRouter();

const searchKeyword = ref("");
const posts = ref([
  {
    id: 1,
    title: "系统更新公告",
    summary: "本次更新修复了若干问题，提升了性能……",
    cover: "https://via.placeholder.com/300x150",
    status: "published"
  },
  {
    id: 2,
    title: "新手攻略指南",
    summary: "教你如何快速上手核心功能……",
    cover: "https://via.placeholder.com/300x150",
    status: "draft"
  }
]);

// 搜索过滤
const filteredPosts = computed(() => {
  if (!searchKeyword.value) return posts.value;
  return posts.value.filter(item =>
      item.title.includes(searchKeyword.value)
  );
});

// 跳转新增页面
const goCreate = () => {
  router.push("/post/create");
};

// 跳转编辑页
const goEdit = id => {
  router.push(`/post/edit/${id}`);
};

// 删除文章
const handleDelete = id => {
  ElMessageBox.confirm("确定删除该文章吗？", "提示", {
    type: "warning"
  }).then(() => {
    posts.value = posts.value.filter(item => item.id !== id);
    ElMessage.success("删除成功");
  });
};

// 请求后端数据（你可以改成接口请求）
const fetchList = () => {
  console.log("刷新搜索结果：", searchKeyword.value);
};
</script>

<style scoped>
.post-page {
  padding: 20px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.search-input {
  width: 300px;
}

.post-card {
  height: 360px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.cover-wrapper {
  height: 150px;
  overflow: hidden;
  border-radius: 6px;
}

.cover {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.info {
  margin-top: 10px;
}

.title {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
}

.desc {
  font-size: 13px;
  color: #666;
  height: 36px;
  overflow: hidden;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
